

















































































































import { Component, Vue } from "vue-property-decorator";
import { GeneralService } from "../services/general-service";
import ProgramLevel from "../components/ProgramLevel.vue";
import config from "../services/api-config";
import router from "../router";
import AuthService from "../services/auth-service";

@Component({
  components: {
    "program-level": ProgramLevel,
  },
})
export default class SubjectSelect extends Vue {
  private service = new GeneralService();
  public entities = [
    { fullName: "Video Lectures" },
    { fullName: "Past Papers" },
    { fullName: "MCQs" },
    { fullName: "Long Questions" },
    { fullName: "Short Questions" },
    { fullName: "Smart Learning" },
    { fullName: "Entry Test Preparation" },
    { fullName: "Ask a Question" },
    { fullName: "Training Courses" },
  ];
  private boards: any = [];
  private activated: boolean = false;
  private boardSelected = false;
  private level_id = JSON.parse(localStorage[config.programSelect] || null);
  private auth = new AuthService();
  private hasMultiple = false;
  private isTrainingEnabled: boolean = false; // Flag to control Training Courses visibility
  private isDitProgram: boolean = false; // Flag to control DIT program visibility
  private showDropdown: boolean = false;
public valuename: any = [];
  public storedInfo: any = [];
  public studentData:any=[];
  private selectModule(name) {
    if (name == "Video Lectures") {
      this.$router.push("/videosubject");
      window.location.reload();
    } else if (name == "MCQs") {
      this.$router.push("/mcqtype");
    } else if (name == "Past Papers") {
      this.$router.push("/pastpapers");
    } else if (name == "Progress") {
      this.$router.push("/progress");
    } else if (name == "Smart Learning") {
      this.$router.push("/videosubject?type=smart");
      window.location.reload();
    } else if (name == "Ask a Question") {
      this.$router.push("/askaquestion");
    } else if (name == "Entry Test Preparation") {
      -this.$router.push("/test-select");
    } else if (name == "Short Questions") {
      this.$router.push("/longshortselect?type=shortquestions");
    } else if (name == "Long Questions") {
      this.$router.push("/longshortselect?type=longquestions");
    } else if (name == "Training Courses") {
      this.$router.push("/trainingcourses");
    }
  }

  private changePart() {
    if (
      parseInt(this.auth.session.varification) == NaN ||
      this.auth.session.varification == "-1"
    ) {
      this.$router.push("select");
      return;
    }
    if (this.level_id.part.indexOf("II") > -1) {
      this.navigateTo(JSON.parse(localStorage[config.studentPartInfo])[0]);
    } else {
      this.navigateTo(JSON.parse(localStorage[config.studentPartInfo])[1]);
    }
  }

  private handlePartSwitch() {
    if (this.isDitProgram) {
      // DIT: show dropdown for semester selection
      this.showDropdown = !this.showDropdown;
    } else {
      // Non-DIT: direct toggle between Part-I and Part-II
      this.changePart();
    }
  }

  private selectPart(index) {
    this.showDropdown = false;
    const storedArr = JSON.parse(localStorage[config.studentPartInfo] || '[]');
    const selectedClass = this.studentData[index];
    if (!selectedClass) return;

    // Find matching entry in storedArr by class name
    const target = storedArr.find(p =>
      p.fullName && selectedClass.Class &&
      p.fullName.replace(/\s+/g, '').toLowerCase() === selectedClass.Class.replace(/\s+/g, '').toLowerCase()
    );

    if (target) {
      this.navigateTo(target);
    }
  }

  private navigateTo(entity) {
    localStorage[config.classLevl] = entity.clId;
    localStorage[config.programSelect] = JSON.stringify({
      val: entity.clId,
      user: this.auth.session.userId,
      part: entity.fullName,
      name: this.auth.session.varification,
      board: this.level_id.board,
    });
    window.location.reload();
  }

  mounted() {
    // Check if DIT program
    if (this.auth.session && this.auth.session.varification &&
        this.auth.session.varification.indexOf('DIT-') !== -1) {
      this.isDitProgram = true;
    }

    if (
      this.level_id == "" ||
      this.level_id == undefined ||
      this.level_id == "null" ||
      this.level_id.user !== this.auth.session.userId
    ) {
      router.push("select");
    }

    this.hasMultiple =
      JSON.parse(localStorage[config.studentPartInfo]).length > 1
        ? true
        : false;
    
    // Fetch student profile to check if training is enabled
    let username = this.auth.session.userName.split("@")[0];
    this.service.getInfoEMS(username).then((result) => {
      if (result && result.data && result.data.length > 0) {
        // Check for isTraining flag in the student profile
        // The API might return isTraining, IsTraining, is_training, or similar
        // this.studentData = result.data[result.data.length - 1]; // Get the latest/current part
        this.studentData = result.data; // Get the latest/current part
        this.storedInfo = localStorage.getItem(config.studentPartInfo);
      let storedArr = typeof this.storedInfo === 'string' ? JSON.parse(this.storedInfo) : this.storedInfo;
 
      // Use the current part from level_id
      let currentPart = (storedArr && this.level_id) ? storedArr.find(p => p.fullName === this.level_id.part) : null;
      this.valuename = currentPart ? this.studentData.find(e => e.Class === currentPart.fullName) : null;

      console.log('Valuename',this.studentData)
 
        // Check multiple possible field names for the training flag
        this.isTrainingEnabled = 
          this.studentData[0].IsTraining === true || 
          this.studentData[0].IsTraining === true || 
          this.studentData[0].is_training === true ||
          this.studentData[0].is_Training === true ||
          false; // Default to false if not found
        
        console.log('Training enabled:', this.isTrainingEnabled, 'Student data:', this.studentData);
      }
    }).catch((err) => {
      console.error('Error fetching student info:', err);
      this.isTrainingEnabled = false;
    });
  }
}
